<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn v-if="adminActions" @click="$emit('newOficialDocumentClicked')">
          {{ $t('Nuevo evento') }}
        </v-btn>
      </v-flex>
      <v-flex>
        <aru-search-entity
          ref="searchEntity"
          v-if="configReady"
          :page="page"
          :search-config="searchConfig"
          :entity="entity"
          v-model="items"
          @loading="page = 1"
          @meta="setPagination"
        ></aru-search-entity>
      </v-flex>
    </v-layout>

    <v-list :two-line="twoLine" :three-line="threeLine" :subheader="addSelectCheckbox">
      <v-list-tile>
        <v-list-tile-action>
          <v-btn
            color="primary"
            small
            v-if="allItemsSelected"
            class="select-all-button"
            @click="onCheckAllClicked()"
          ></v-btn>
          <v-btn
            color="info"
            small
            v-if="!allItemsSelected"
            outline
            class="select-all-button"
            @click="onCheckAllClicked()"
          ></v-btn>
        </v-list-tile-action>
        <v-list-tile-action>
          <v-btn flat small @click="onCheckAllClicked()">{{ $t('Seleccionar todos') }}</v-btn>
        </v-list-tile-action>
        <!--        <v-list-tile-action>-->
        <!--          <v-btn-->
        <!--            v-if="anySelected"-->
        <!--            color="primary"-->
        <!--            :loading="multiDownloading"-->
        <!--            small-->
        <!--            outline-->
        <!--            class="ml-3 pa-2"-->
        <!--            @click="multiDownload()"-->
        <!--          >-->
        <!--            <v-icon>mdi-download-outline</v-icon>-->
        <!--            {{ $t('Descargar') }}-->
        <!--          </v-btn>-->
        <!--        </v-list-tile-action>-->
        <v-list-tile-action v-if="allItemsSelected">
          <v-menu class="ml-3">
            <v-btn
              slot="activator"
              color="primary"
              dark
              flat
              small
              outline
              min-width="100"
              class="pa-2"
              @click="downloadAllDocuments()"
            >
              {{ $t('Descargar todos') }}
            </v-btn>
          </v-menu>
        </v-list-tile-action>
        <v-list-tile-action v-if="anySelected">
          <v-menu class="ml-3">
            <v-btn
              slot="activator"
              color="primary"
              dark
              flat
              small
              outline
              min-width="100"
              class="pa-2"
              @click="downloadSelectedDocuments()"
            >
              {{ $t('Descargar selección') }}
            </v-btn>
          </v-menu>
        </v-list-tile-action>
        <v-list-tile-action v-if="anySelected">
          <v-menu class="ml-3">
            <v-btn
              slot="activator"
              color="primary"
              dark
              flat
              small
              outline
              min-width="100"
              class="pa-2"
              @click="deleteMassiveDocument()"
            >
              {{ $t('Eliminar selección') }}
            </v-btn>
            <!--            <v-list>-->
            <!--              <v-list-tile @click="changeMassiveStatus('confirmed')">-->
            <!--                <v-list-tile-title>-->
            <!--                  {{ $t('Confirmado') }}-->
            <!--                </v-list-tile-title>-->
            <!--              </v-list-tile>-->
            <!--              <v-list-tile @click="changeMassiveStatus('in_progress')">-->
            <!--                <v-list-tile-title>-->
            <!--                  {{ $t('Sin confirmar') }}-->
            <!--                </v-list-tile-title>-->
            <!--              </v-list-tile>-->
            <!--              <v-list-tile @click="deleteMassiveDocument()">-->
            <!--                <v-list-tile-title class="error&#45;&#45;text">-->
            <!--                  {{ $t('Eliminar') }}-->
            <!--                </v-list-tile-title>-->
            <!--              </v-list-tile>-->
            <!--            </v-list>-->
          </v-menu>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <div v-if="readyToList" class="v-table__overflow">
      <table class="v-datatable v-table theme--light">
        <thead>
          <th>Selección</th>
          <th v-for="(field, i) in header" :key="i">{{ $t(field) }}</th>
        </thead>
        <tbody>
          <oficial-document-table-row
            :admin-actions="adminActions"
            @entityDeleted="getEntities"
            v-for="item in items"
            :default-icon="defaultIcon"
            :key="item.id"
            :entity="item"
            :config="config"
            :level="level"
          ></oficial-document-table-row>
        </tbody>
      </table>
      <div class="text-xs-center" v-if="showPagination">
        <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import AruListMixin from '@/mixins/list/AruListMixin.js';
import OficialDocumentTableRow from './OficialDocumentTableRow';
import AruSearchEntity from '@/components/commons/search/AruSearchEntity';
export default {
  mixins: [AruListMixin],
  components: {
    OficialDocumentTableRow,
    AruSearchEntity,
  },
  props: {
    adminActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      header: [
        'Documento',
        'Creado',
        'Actualizado',
        'Estado',
        'Tipo',
        'Mes',
        'Cod. Cliente',
        'Trabajador',
        'Acciones',
      ],
    };
  },
  methods: {
    deleteMassiveDocument() {
      const idsIfSelected = (ids, item) => {
        if (item.selected) {
          ids.push(item.id);
        }
        return ids;
      };

      const ids = this.items.reduce(idsIfSelected, []);

      apiCtrl.post('/consultant-document/delete-massive', { documents: ids }).then(res => {
        console.log({ DOCUMENTS: res });
        this.$refs.searchEntity.getEntities();
        // this.AruSearchEntity.getEntities();
      });
    },
    downloadAllDocuments() {
      let config = {};
      config.params = this.$refs.searchEntity.params;
      config.params.name = `download-${Math.random()
        .toString(36)
        .substring(7)}`;

      return apiCtrl.downloadBlob('/consultant-document/download-all', config);
    },
    downloadSelectedDocuments() {
      const idsIfSelected = (ids, item) => {
        if (item.selected) {
          ids.push(item.id);
        }
        return ids;
      };

      const ids = this.items.reduce(idsIfSelected, []);

      return apiCtrl.downloadBlob('/consultant-document/download-massive', {
        params: {
          name: `download-${Math.random()
            .toString(36)
            .substring(7)}`,
          ids: ids,
        },
      });
    },
  },
};
</script>

<style>
.select-all-button {
  width: 16px;
  min-width: 16px;
  height: 16px;
}

.v-list__tile__action .select-all-button {
  margin: 4px;
  padding: 0;
}
</style>
